/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * smoothScrollToTopBtn.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * ページトップボタン
 */

function scrollToTopBtn() {
	const toTopBtn = document.getElementById('totop');
	if (!toTopBtn) return;

	toTopBtn.addEventListener('click', scrollToTop);
	toTopBtnScrollEvent(toTopBtn);

	function scrollToTop() {
		window.scroll({
			top: 0,
			behavior: 'smooth'
		});
	}
}

/**
 * 表示・非表示アクション
 */
function toTopBtnScrollEvent(toTopBtn) {
	window.addEventListener('scroll', scroll_event);

	function scroll_event() {
		if (window.pageYOffset > 400) {
			toTopBtn.style.opacity = '1';
		} else if (window.pageYOffset < 400) {
			toTopBtn.style.opacity = '0';
		}
	}
}

export {
	scrollToTopBtn
};